import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;

  flex: 1;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  max-width: 516px;
`;

export const DatePlanificationWrapper = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    & > * {
      width: 50%;
    }
  }
`;

export const InfoCardWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  & > span {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.purple3};
    background: ${({ theme }) => theme.colors.purple1};
    flex-shrink: 0;
  }
`;

export const TextWrapper = styled(Flex)`
  gap: 8px;
`;

export const TitleWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const AlertTitle = styled.span`
  width: 100%;
  text-align: start;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ContentWrapper = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
